module.exports = __webpack_public_path__ + "img/kastina.a5072eed.png";